/*---------------------------------------------------------------------------------*/ 
/* Doran App Integration ----------------------------------------------------------*/ 
/*---------------------------------------------------------------------------------*/
(() => {
function waitForIframeReadyAndInjectCSS(iframe, cssUrl, label = '') {
	if (!iframe) {
		// console.warn(`⛔ Iframe not found for ${label}`);
		return;
	}
	if (!cssUrl) {
		// console.warn(`⛔ CSS URL not defined for ${label}`);
		return;
	}
	// console.log(`🔄 Fetching CSS for ${label} from: ${cssUrl}`);
	fetch(cssUrl)
		.then(response => {
			if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
			return response.text();
		})
		.then(cssContent => {
			// console.log(`✅ CSS fetched for ${label}, waiting for iframe contentDocument...`);
			const maxRetries = 40; // 2 seconds total
			let retries = 0;
			const interval = setInterval(() => {
				const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
				if (iframeDoc && iframeDoc.head) {
					clearInterval(interval);
					try {
						const styleTag = iframeDoc.createElement('style');
						styleTag.textContent = cssContent;
						iframeDoc.head.appendChild(styleTag);
						// console.log(`🎉 CSS injected into ${label} iframe`);
					} catch (err) {
						// console.error(`❌ Error injecting CSS into ${label}:`, err);
					}
				} else {
					retries++;
					if (retries >= maxRetries) {
						clearInterval(interval);
						// console.warn(`⛔ Timeout: iframe never became ready for ${label}`);
					}
				}
			}, 50);
		})
		.catch(err => {
			// console.error(`❌ Failed to fetch CSS for ${label}:`, err);
		});
}

function waitForShadowRootAndInjectCSS(element, cssUrl, label = '') {
	if (!element) {
		return;
	}
	if (!cssUrl) {
		return;
	}

	fetch(cssUrl)
		.then(response => {
			if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
			return response.text();
		})
		.then(cssContent => {
			const maxRetries = 80;
			let retries = 0;
			const interval = setInterval(() => {
				const shadowRoot = element.shadowRoot;
				if (shadowRoot) {
					clearInterval(interval);
					try {
						if (shadowRoot.querySelector(`style[data-emhdi-app-css="${label}"]`)) {
							return;
						}

						const styleTag = document.createElement('style');
						styleTag.setAttribute('data-emhdi-app-css', label);
						styleTag.textContent = cssContent;
						shadowRoot.appendChild(styleTag);
					} catch (err) {
						// console.error(`❌ Error injecting CSS into ${label}:`, err);
					}
				} else {
					retries++;
					if (retries >= maxRetries) {
						clearInterval(interval);
					}
				}
			}, 50);
		})
		.catch(err => {
			// console.error(`❌ Failed to fetch CSS for ${label}:`, err);
		});
}

const injectedFrames = new WeakSet();
const processIframe = (iframe, cssUrl, label) => {
	if (!iframe || injectedFrames.has(iframe)) return;

	waitForIframeReadyAndInjectCSS(iframe, cssUrl, label);
	injectedFrames.add(iframe);
};

const injectedShadowHosts = new WeakSet();
const processShadowHost = (element, cssUrl, label) => {
	if (!element || injectedShadowHosts.has(element)) return;

	waitForShadowRootAndInjectCSS(element, cssUrl, label);
	injectedShadowHosts.add(element);
};

const fixUncrawlableLinks = () => {
	document.querySelectorAll('a:not([href])').forEach(a => a.setAttribute('href', '#'));
};

const mutationObserver = new MutationObserver(() => {
	fixUncrawlableLinks();
	const ratingIframe = document.querySelectorAll('div[data-class-name="product-rating__widget"] iframe');
	ratingIframe.forEach(iframe => {
		processIframe(iframe, cssUrl_Doran_Rating, 'Rating');
	});
	const qaIframe = document.querySelectorAll('#doran-product-question-widget iframe');
	qaIframe.forEach(iframe => {
		processIframe(iframe, cssUrl_Doran_QA, 'Q&A');
	});
	const reviewIframe = document.querySelectorAll('#doran-product-widget iframe');
	reviewIframe.forEach(iframe => {
		processIframe(iframe, cssUrl_Doran_Review, 'Review');
	});
	const galleryIframes = document.querySelectorAll('.dr-media-preview-modal iframe');
	galleryIframes.forEach(iframe => {
		processIframe(iframe, cssUrl_Doran_Gallery, 'Gallery');
	});
	const reviewsShowCaseIframe = document.querySelectorAll('div[data-dr="showcase-page"] iframe');
	reviewsShowCaseIframe.forEach(iframe => {
		processIframe(iframe, cssUrl_Doran_ReviewsShowCase, 'ReviewsShowCase');
	});

	const shopifyForms = document.querySelectorAll('shopify-forms-embed');
	shopifyForms.forEach(formEmbed => {
		processShadowHost(formEmbed, cssUrl_Shopify_Forms, 'ShopifyForms');
	});
});

function startObserver() {
	if (!document.body) return;

	fixUncrawlableLinks();
	mutationObserver.observe(document.body, {
		childList: true,
		subtree: true
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', startObserver, { once: true });
} else {
	startObserver();
}
})();
